import { Modal, Button } from "react-bootstrap";

function TerminateConfirmationModal({ 
  isOpen, 
  title, 
  message, 
  description, 
  primaryButtonText = "Terminate", 
  secondaryButtonText = "Cancel", 
  onPrimaryClick, 
  onSecondaryClick,
  isLoading = false
}) {
  return (
    <Modal 
      show={isOpen} 
      onHide={onSecondaryClick} 
      centered 
      backdrop="static" 
      keyboard={false}
      className="custom--modal"
    >
      {/* Modal Header */}
      {title && (
        <div className="modal-header m-0">
          <h2 style={{ color: "var(--danger-color)" }}>{title}</h2>
          <button className="close-button" onClick={onSecondaryClick}>
            ✕
          </button>
        </div>
      )} 

      {/* Modal Body */}
      <Modal.Body className="text-center py-4" style={{ backgroundColor: "var(--bg-primary)", color: "var(--text-primary)" }}>
        <div 
          className="d-flex align-items-center justify-content-center mb-3"
          style={{
            width: "80px",
            height: "80px",
            margin: "0 auto",
            borderRadius: "50%",
            backgroundColor: "rgba(220, 53, 69, 0.1)",
            color: "var(--danger-color)"
          }}
        >
          <svg
            width="40"
            height="40"
            fill="currentColor"
            viewBox="0 0 16 16"
          >
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
          </svg>
        </div>
        <h5 className="fw-semibold">
          {message}
        </h5>
        {description && (
          <div 
            className="mt-3 p-3 rounded"
            role="alert"
            style={{
              backgroundColor: "rgba(220, 53, 69, 0.1)",
              border: "1px solid var(--danger-color)",
              color: "var(--danger-color)"
            }}
          >
            {description}
          </div>
        )}
      </Modal.Body>

      {/* Modal Footer */}
      <Modal.Footer style={{ backgroundColor: "var(--bg-primary)", borderTop: "1px solid var(--border-color)" }}>
        {onSecondaryClick && (
          <Button 
            variant="outline-secondary" 
            onClick={onSecondaryClick}
            className="modal-button secondary"
            disabled={isLoading}
          >
            {secondaryButtonText}
          </Button>
        )}
        <Button 
          onClick={onPrimaryClick}
          className="modal-button primary d-flex align-items-center justify-content-center"
          disabled={isLoading}
          style={{
            backgroundColor: "var(--danger-color)",
            borderColor: "var(--danger-color)",
            color: "#ffffff"
          }}
        >
          {isLoading ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              {primaryButtonText}
            </>
          ) : (
            primaryButtonText
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default TerminateConfirmationModal;

